<template>
  <div class="ic-form__topics mt-3">
    <IcFormRowWrapper
      name="topic"
      new_id="topic"
      :aria="$t('aria_required')"
      label
      :labelWidth="4"
      :controlWidth="8"
    >
      <template slot-scope="{validator}">
        <IcRadioGroup
          :id="'topic'"
          v-model="topic"
          :options="topics"
          @input="emitInput(topic,validator)"
        ></IcRadioGroup>
      </template>
    </IcFormRowWrapper>
  </div>
</template>

<script>
//import IcFormRowWrapper from "@/components/ic-common/form/helpers/FormRowWrapper";
import IcRadioGroup from "@/components/ic-common/form/controls/RadioGroup";
import { emitInput } from "./mixins";

export default {
  name: "IcFormContactTopics",
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  mounted() {},
  data() {
    return {
      topics: [
        { id: 1, name: this.$t("contact_topic_1") },
        { id: 2, name: this.$t("contact_topic_2") },
        {
          id: 3,
          name: this.$t("contact_topic_3")
        },
        { id: 4, name: this.$t("contact_topic_4") }
      ],
      topic: this.value
    };
  },
  methods: {
    emitInput
  },
  components: {
    // IcFormRowWrapper,
    IcRadioGroup
  }
};
</script>

<style>
</style>
